import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-question-modal',
  templateUrl: './question-modal.component.html',
  styleUrls: ['../modal.component.scss']
})
export class QuestionModalComponent {
  @Input() text;
  @Output() readonly responseChanged = new EventEmitter();

  emitTrue(): void {
   this.responseChanged.emit(true);
  }

  emitFalse(): void {
    this.responseChanged.emit(false);
  }
}
